import type { AgendaConsultant } from "./agendaTypes";

/** Keeps the API order but moves the viewer (a consultant) to the top of the list. */
export function orderConsultantsForViewer(
  consultants: AgendaConsultant[],
  viewerId?: number | null
): AgendaConsultant[] {
  if (viewerId == null) {
    return consultants;
  }
  const viewer = consultants.find((consultant) => consultant.id === viewerId);
  if (!viewer) {
    return consultants;
  }
  return [viewer, ...consultants.filter((consultant) => consultant.id !== viewerId)];
}

/**
 * A saved consultant filter can point to someone outside the current scope (e.g. after
 * switching teams). Returns true when the filter should be cleared.
 */
export function isConsultantFilterOutOfScope(
  consultantId: number | undefined,
  options: AgendaConsultant[]
): boolean {
  if (consultantId == null || options.length === 0) {
    return false;
  }
  return !options.some((consultant) => consultant.id === consultantId);
}
